import { useEffect, useRef } from 'react';
import { gsap } from '../lib/gsapSetup';

export default function ScrubWords({ text, className = '', testId }) {
  const ref = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ref.current.querySelectorAll('.scrub-word'),
        { opacity: 0.13 },
        {
          opacity: 1,
          stagger: 0.05,
          duration: 0.5,
          ease: 'none',
          scrollTrigger: {
            trigger: ref.current,
            start: 'top 75%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <p ref={ref} data-testid={testId} className={className}>
      {text.split(' ').map((word, i) => (
        <span key={i} className="scrub-word inline-block">
          {word}
          {i < text.split(' ').length - 1 ? '\u00A0' : ''}
        </span>
      ))}
    </p>
  );
}
